class Tools {
    constructor() {
        this.DEG2RAD = 0.0174533;
        this.RAD2DEG = 57.2958;
    }

    rand(min, max) {
        return Math.random() * (max - min) + min;
    };

    // Returns the random number in [minNum,maxNum]
    randomNum(minNum, maxNum) {
        switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * minNum + 1, 10);
            case 2:
                return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            default:
                return 0;
        }
    }

    // Split array into groups with random number of objects, min and max are the limits for the split
    randChunkSplit(arr, min, max) {
        var arr = arr.slice();
        var arrs = [], size = 1;
        var min = min || 1;
        var max = max || min || 1;
        while (arr.length > 0) {
            size = Math.min(max, Math.floor((Math.random() * max) + min));
            arrs.push(arr.splice(0, size));
        }
        return arrs;
    }

    mod(value, n) {
        return ((value % n) + n) % n;
    };

    clamp(number, min, max) {
        return Math.min(Math.max(number, min), max);
    };

    // Get the portion using the value between min and max
    inverseLerp(min, max, value) {
        value = value < min ? min : value;
        value = value > max ? max : value;
        let portion = (value - min) / (max - min);
        return portion;
    }

    // Get the linear interpolation between two value
    lerp(min, max, portion) {
        portion = portion < 0 ? 0 : portion;
        portion = portion > 1 ? 1 : portion;
        let value = min + (max - min) * portion;
        return value;
    }

    // Get the new portion using the old portion
    remapPortion(inputMin, inputMax, inputPortion, outputMin, outputMax) {
        let portion = this.lerp(inputMin, inputMax, inputPortion);
        let outputPortion = this.inverseLerp(outputMin, outputMax, portion);
        return outputPortion;
    }

    // Get the new value using the old value
    remapValue(inputMin, inputMax, inputValue, outputMin, outputMax) {
        let t = this.inverseLerp(inputMin, inputMax, inputValue);
        let outputValue = this.lerp(outputMin, outputMax, t);
        return outputValue;
    }

    // Convert the rad into rad within 0 to 2pi
    simplifyRad(rad) {
        var result = null;
        result = Math.atan(Math.tan(rad));
        if (result < 0) {
            result = 2 * Math.PI + result;
        }
        return result;
    }

    getClonedModel(Object) {

        let clonedGltf = this.cloneGltf(Object);

        let clonedMesh = !this.isModelAnimated
            ? clonedGltf.scene.children[0]
            : clonedGltf.scene.getObjectByName("ctrl_catapult");
        return { clonedGltf, clonedMesh };
    }


    isFunc(funcName) {
        return typeof funcName !== "undefined";
    };

    clean(displayObject) {
        if (!displayObject) {
            return;
        }

        if (displayObject.isMesh) {
            displayObject.parent && displayObject.parent.remove(displayObject);
            displayObject.geometry.dispose();
            displayObject.material.dispose();
        } else {
            while (displayObject.children.length > 0) {
                let obj = displayObject.children[0];
                if (obj.isMesh) {
                    displayObject.remove(obj);
                    obj.geometry.dispose();
                    obj.material.dispose();
                } else if (obj.children && obj.children.length > 0) {
                    this.clean(obj);
                } else {
                    displayObject.remove(obj);
                }
            }
        }
    }

    hashtagToHexa(color) {
        return "0x" + color.split("#")[1];
    }

    shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }

    loadFont(fonts, callback) {
        this.fonts = fonts;
        this.callback = callback;
        this.strTest = "giItTWQy01234&@=-i?0";
        this._noFont = document.createElement("div");
        document.body.appendChild(this._noFont);
        this._noFont.innerText = this.strTest;
        this._noFont.style.display = "inline";
        this._noFont.style.visibility = "hidden";
        this._noFont.style.position = "fixed";
        this._myFont = document.createElement("div");
        document.body.appendChild(this._myFont);
        this._myFont.innerText = this.strTest;
        this._myFont.style.display = "inline";
        this._myFont.style.visibility = "hidden";
        this._myFont.style.position = "fixed";
        this.tryLoad();
        this.id = 0;

    };


    tryLoad() {

        this.timer = setInterval(() => {

            this._myFont.style.fontFamily = this.fonts[this.id];

            if (this._noFont.getBoundingClientRect().width !== this._myFont.getBoundingClientRect().width) {
                console.log(this.fonts[this.id] + " loaded");
                if (this.id >= this.fonts.length - 1) {
                    clearInterval(this.timer);
                    document.body.removeChild(this._noFont);
                    document.body.removeChild(this._myFont);
                    setTimeout(() => {
                        this.callback();
                    }, 100);
                } else {
                    this.id++;
                }
            }

            console.log("fonts loading");

        }, 100);
    }


}

export default new Tools();